import React, { Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { Table } from '../'

export const TableCard = ({title, isButtonEnable, buttonText, path, contentRowNames,
                            headers, itemsCount, pageSize, currentPage, onPageChange, data, handleClick}) => {
    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={isButtonEnable}
                            buttonText={buttonText}
                            path={path} />
                    
                        <div className="card-body">
                          
                            <Table
                                headers={headers}
                                itemsCount={itemsCount}
                                pageSize={pageSize}
                                currentPage={currentPage}
                                onPageChange={onPageChange}
                                data={data}
                                handleClick={handleClick}
                                contentRowNames={contentRowNames}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}